import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 63353DF0-B961-42CD-88D6-FA40887FD3DC
 * name arrow-top-left-bold-box-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-left-bold-box-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowTopLeftBoldBoxOutlineIcon = createSvgIcon(<><path d="M8 8H15.1L13 10.1L17 14L14.2 16.8L10.1 12.9L8 15.1V8M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19Z" /></>, 'ArrowTopLeftBoldBoxOutlineIcon');
export default ArrowTopLeftBoldBoxOutlineIcon